import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedAppModule } from '../app.module.shared';

import { AdminRoutingModule } from './admin.routing.module';

import { UsersComponent } from './users/users.component';


@NgModule({
    declarations: [
        UsersComponent,
  
    ],
    imports: [
		CommonModule,
		SharedAppModule,
        AdminRoutingModule,
        ReactiveFormsModule,
        FormsModule
    ]
})
export class AdminModule { }

